import React from 'react'
import './consulting-room-content.scss'
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb'
import HeaderConsultingRoom from '../../molecules/header-consulting-room/header-consulting-room';
import AlsoConsulted from '../also-consulted/also-consulted';
import BodyConsultingRoom from '../../molecules/body-consulting-room/body-consulting-room';

const ConsultingRoomContent = (props) => {
    const { mobile, context, menu, setModalActive } = props;
    return (
        <div className='f-consulting-room-content'>
            <div className="f-breadcrum-position">
                <Breadcrumb mobile={mobile} />
            </div>
            <HeaderConsultingRoom menu={menu} mobile={mobile} title={context.titulo} banner={context.banner} />
            <BodyConsultingRoom 
            context={context}
            setModalActive={setModalActive} />
            <AlsoConsulted tags={context.etiquetas} imgConsulting={context.imagenMiniatura} titleDoctor={context.titulo} slug={context.slug} setModalActive={setModalActive} mobile={mobile} />

        </div>
    )
}

export default ConsultingRoomContent
